import {Avatar, SxProps} from '@mui/material';
import {useMemo} from 'react';
import {Tooltip} from '../../../../../../../components/tooltip/tooltip';
import {useEntity} from '../../../../../../../contexts/entity/context';
import {userSocialResponseMainColor} from './user-social-response-main-color';

export type UserAvatarProps = {
  // user: AffiliatedUser;
  name: string;
  picture?: string;
  socialResponses?: string[];
  size: 's' | 'm' | 'l';
  sx?: SxProps;
  disableTooltip?: boolean;
  className?: string;
};

export function UserAvatar(props: UserAvatarProps) {
  const entityContext = useEntity();

  const sizeMap: Record<UserAvatarProps['size'], string> = {
    s: '22px',
    m: '26px',
    l: '34px',
  };

  const borderSize: Record<UserAvatarProps['size'], string> = {
    s: '1px',
    m: '1.5px',
    l: '2px',
  };

  const borderColor = useMemo(() => {
    return userSocialResponseMainColor(
      props.socialResponses,
      entityContext.state.userEntitySocialResponses
    );
  }, [entityContext.state.userEntitySocialResponses, props.socialResponses]);

  return (
    <Tooltip.If condition={!props.disableTooltip} title={props.name}>
      <Avatar
        alt={props.name}
        src={props.picture}
        style={{
          border: borderColor ? `${borderSize[props.size]} solid ${borderColor}` : undefined,
        }}
        sx={{
          width: sizeMap[props.size],
          height: sizeMap[props.size],
          ...props.sx,
        }}
        className={props.className}
      />
    </Tooltip.If>
  );
}
